import { Loading } from "@components/LoadMore/LoadMore";
import { useSetUserInfo } from "@features/mySph/hooks/useSetUserInfo";

export const AuthDetails = () => {
  const { isLoading } = useSetUserInfo();

  return <Loading isLoading={isLoading} />;
};
